export default {
  rootFontSizePx: 14,
};
